import { Controller } from "@hotwired/stimulus";
import * as Toastr from 'toastr';
import 'toastr/build/toastr.css';

export default class extends Controller {
  static values = { email: String, id: String }

  async send(event) {
    event.preventDefault();

    try {
      const response = await fetch('/postmark_invitations', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content 
        },
        body: `email=${encodeURIComponent(this.emailValue)}`
      });

      const data = await response.json();

      if (response.ok) {
        Toastr.success('Invite email sent successfully!');
      } else {
        Toastr.error(data.error || 'Failed to send invite email. Please try again.');
      }
    } catch (error) {
      console.error('Error', error);
      Toastr.error('Failed to send invite email. Please try again.');
    }
  }

  async resend(event) {
    event.preventDefault();

    try {
      const response = await fetch(`/postmark_invitations/${this.idValue}`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content 
        },
      });

      const data = await response.json();

      if (response.ok) {
        Toastr.success('Confirmation email sent successfully!');
      } else {
        Toastr.error(data.error || 'Failed to send confirmation email. Please try again.');
      }
    } catch (error) {
      console.error('Error', error);
      Toastr.error('Failed to send confirmation email. Please try again.');
    }
  }
} 